import { render, staticRenderFns } from "./MessageCategoryIsDone.vue?vue&type=template&id=7c2cdcce&"
import script from "./MessageCategoryIsDone.vue?vue&type=script&lang=ts&"
export * from "./MessageCategoryIsDone.vue?vue&type=script&lang=ts&"
import style0 from "./MessageCategoryIsDone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports